import Loadable from '../../components/loadable';

const StyleList = Loadable({
  loader: () => import('../../pages/gradings/style_list'),
  type: 'block',
});

angular.module('gym').value('StyleList', StyleList);
